import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const priceData = [{
  month: 'Sep',
  price: 242
}, {
  month: 'Oct',
  price: 245
}, {
  month: 'Nov',
  price: 252
}, {
  month: 'Dec',
  price: 248
}, {
  month: 'Jan',
  price: 261
}, {
  month: 'Feb',
  price: 258
}, {
  month: 'Mar',
  price: 271,
  predicted: true
}, {
  month: 'Apr',
  price: 268,
  predicted: true
}, {
  month: 'May',
  price: 275,
  predicted: true
}];
function PriceChart() {
  const max = Math.max(...priceData.map(d => d.price));
  const min = Math.min(...priceData.map(d => d.price));
  const range = max - min;
  const w = 300,
    h = 100;
  const points = priceData.map((d, i) => ({
    x: i / (priceData.length - 1) * w,
    y: h - (d.price - min) / range * (h - 16) - 8,
    ...d
  }));
  const solid = points.filter(p => !p.predicted);
  const predicted = points.filter(p => p.predicted);
  const last = solid[solid.length - 1];
  const solidPath = solid.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ');
  const predPath = [last, ...predicted].map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ');
  const areaPath = `${solidPath} L ${last.x} ${h} L ${solid[0].x} ${h} Z`;
  return <div className="rounded-2xl border border-[#E8E4DC] bg-white overflow-hidden shadow-sm" data-id="element-1">
      <div className="px-5 pt-5 pb-4" data-id="element-2">
        <div className="flex items-center justify-between mb-4" data-id="element-3">
          <div data-id="element-4">
            <div className="text-xs font-jakarta font-bold text-[#0F0E0C]" data-id="element-5">
              40s Combed Cotton · Price Forecast
            </div>
            <div className="text-[10px] text-[#9B9890] font-inter mt-0.5" data-id="element-6">
              30–90 day AI prediction
            </div>
          </div>
          <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#FFF0E8] border border-[#FDDCCC] text-[10px] text-[#E8500A] font-inter font-semibold" data-id="element-7">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E8500A] pulse-dot inline-block" data-id="element-8"></span>
            Live
          </div>
        </div>
        <svg width={w} height={h + 20} className="overflow-visible w-full" viewBox={`0 0 ${w} ${h + 20}`} data-id="element-9">
          <defs data-id="element-10">
            <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1" data-id="element-11">
              <stop offset="0%" stopColor="#E8500A" stopOpacity="0.12" data-id="element-12" />
              <stop offset="100%" stopColor="#E8500A" stopOpacity="0" data-id="element-13" />
            </linearGradient>
          </defs>
          <path d={areaPath} fill="url(#areaGrad)" data-id="element-14" />
          <path d={solidPath} stroke="#E8500A" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-15" />
          <path d={predPath} stroke="#10B981" strokeWidth="2" fill="none" strokeDasharray="5 3" strokeLinecap="round" data-id="element-16" />
          {points.map((p, i) => <circle key={i} cx={p.x} cy={p.y} r="3" fill={p.predicted ? '#10B981' : '#E8500A'} stroke="white" strokeWidth="1.5" data-id="element-17" />)}
          {points.map((p, i) => <text key={i} x={p.x} y={h + 16} textAnchor="middle" fontSize="7" fill={p.predicted ? '#10B981' : '#9B9890'} fontFamily="Inter" data-id="element-18">
              {p.month}
            </text>)}
        </svg>
        <div className="flex items-center gap-4 mt-2" data-id="element-19">
          <div className="flex items-center gap-1.5" data-id="element-20">
            <div className="w-3 h-0.5 bg-[#E8500A] rounded" data-id="element-21"></div>
            <span className="text-[10px] text-[#9B9890] font-inter" data-id="element-22">
              Actual
            </span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-23">
            <div className="w-3 h-0.5 bg-emerald-500 rounded" data-id="element-24"></div>
            <span className="text-[10px] text-emerald-600 font-inter" data-id="element-25">
              AI Forecast
            </span>
          </div>
        </div>
      </div>
      <div className="mx-5 mb-4 p-3 rounded-xl bg-[#FFF7F3] border border-[#FDDCCC] flex items-start gap-2.5" data-id="element-26">
        <div className="w-5 h-5 rounded-full bg-[#E8500A] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-27">
          <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-28">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-29" />
          </svg>
        </div>
        <div data-id="element-30">
          <div className="text-[10px] font-inter font-bold text-[#E8500A]" data-id="element-31">
            Price Alert
          </div>
          <div className="text-[10px] text-[#C04008] font-inter leading-relaxed" data-id="element-32">
            40s combed expected to rise 6.5% by March. Consider buying now.
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 border-t border-[#F0EDE8]" data-id="element-33">
        {[{
        label: 'Accuracy',
        value: '94%'
      }, {
        label: 'Forecast Window',
        value: '90 days'
      }, {
        label: 'Yarn Types',
        value: '200+'
      }].map((s, i) => <div key={i} className={`px-4 py-3 text-center ${i < 2 ? 'border-r border-[#F0EDE8]' : ''}`} data-id="element-34">
            <div className="font-jakarta font-extrabold text-sm text-[#0F0E0C]" data-id="element-35">
              {s.value}
            </div>
            <div className="text-[9px] text-[#9B9890] font-inter mt-0.5" data-id="element-36">
              {s.label}
            </div>
          </div>)}
      </div>
    </div>;
}
function ProcurementDemo() {
  const suppliers = [{
    name: 'Shree Textiles, Coimbatore',
    price: '₹254/kg',
    delivery: '5 days',
    match: 98
  }, {
    name: 'Arvind Yarns, Ahmedabad',
    price: '₹258/kg',
    delivery: '6 days',
    match: 94
  }, {
    name: 'Krishna Fibres, Tirupur',
    price: '₹256/kg',
    delivery: '7 days',
    match: 91
  }];
  return <div className="rounded-2xl border border-[#E8E4DC] bg-white overflow-hidden shadow-sm" data-id="element-37">
      <div className="flex items-center justify-between px-5 py-3.5 border-b border-[#F0EDE8] bg-[#FAFAF8]" data-id="element-38">
        <div className="flex items-center gap-2" data-id="element-39">
          <div className="w-6 h-6 rounded-lg bg-[#FFF0E8] border border-[#FDDCCC] flex items-center justify-center" data-id="element-40">
            <svg className="w-3 h-3 text-[#E8500A]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-41">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" data-id="element-42" />
            </svg>
          </div>
          <span className="text-xs font-jakarta font-bold text-[#0F0E0C]" data-id="element-43">
            Marketplace Copilot
          </span>
        </div>
        <span className="text-[10px] text-[#9B9890] font-inter" data-id="element-44">
          Natural language sourcing
        </span>
      </div>
      <div className="p-4 space-y-3" data-id="element-45">
        <div className="flex justify-end" data-id="element-46">
          <div className="max-w-[85%] px-3.5 py-2.5 rounded-2xl rounded-tr-sm bg-[#E8500A] text-white text-xs font-inter leading-relaxed" data-id="element-47">
            Find 40s combed cotton under ₹260/kg, delivery within 7 days
          </div>
        </div>
        <div className="flex gap-2.5 items-start" data-id="element-48">
          <div className="w-6 h-6 rounded-full bg-[#FFF0E8] border border-[#FDDCCC] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-49">
            <svg className="w-3 h-3 text-[#E8500A]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-50">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" data-id="element-51" />
            </svg>
          </div>
          <div className="text-xs text-[#5C5A55] font-inter py-1 leading-relaxed" data-id="element-52">
            Found{' '}
            <strong className="text-[#0F0E0C]" data-id="element-53">3 verified suppliers</strong>{' '}
            matching your criteria:
          </div>
        </div>
        <div className="space-y-2" data-id="element-54">
          {suppliers.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -8
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1 + 0.2
        }} whileHover={{
          x: 2,
          transition: {
            duration: 0.15
          }
        }} className="flex items-center justify-between p-3 rounded-xl border border-[#E8E4DC] bg-[#FAFAF8] hover:border-[#E8500A]/30 hover:bg-[#FFF7F3] transition-all cursor-pointer" data-id="element-55">
              <div data-id="element-56">
                <div className="text-xs font-inter font-semibold text-[#0F0E0C]" data-id="element-57">
                  {s.name}
                </div>
                <div className="text-[10px] text-[#9B9890] font-inter mt-0.5" data-id="element-58">
                  {s.delivery} delivery
                </div>
              </div>
              <div className="text-right" data-id="element-59">
                <div className="text-xs font-inter font-bold text-[#0F0E0C]" data-id="element-60">
                  {s.price}
                </div>
                <div className="text-[10px] text-[#E8500A] font-inter font-semibold mt-0.5" data-id="element-61">
                  {s.match}% match
                </div>
              </div>
            </motion.div>)}
        </div>
        <div className="flex gap-2 pt-1" data-id="element-62">
          <button className="flex-1 py-2 rounded-xl bg-[#E8500A] hover:bg-[#D14508] text-white text-[11px] font-inter font-semibold transition-colors" data-id="element-63">
            Generate RFQ
          </button>
          <button className="flex-1 py-2 rounded-xl border border-[#E8E4DC] text-[#5C5A55] text-[11px] font-inter hover:border-[#D4CFC5] hover:bg-[#F5F4F0] transition-all" data-id="element-64">
            Compare All
          </button>
        </div>
      </div>
    </div>;
}
const products = [{
  id: 'intelligence',
  label: 'Price Intelligence',
  eyebrow: 'AI Market Intelligence',
  title: 'Know what yarn will cost — before you buy.',
  tagline: 'Stop guessing. Start forecasting.',
  description: "Powered by India's richest yarn transaction dataset, our AI forecasts prices 30–90 days ahead by count, blend, and region. Get ahead of market movements before your competitors do.",
  points: ['Price forecasting by count, blend & region', 'Demand prediction 30–90 days ahead', 'Spike & shortage alerts in real time', 'Optimal buy timing recommendations'],
  for: 'Mills · Traders · Garment Exporters',
  demo: <PriceChart data-id="element-65" />
}, {
  id: 'copilot',
  label: 'Procurement Copilot',
  eyebrow: 'AI Marketplace Copilot',
  title: 'Source in plain language. Close in minutes.',
  tagline: 'Your smartest procurement team member.',
  description: 'Just describe what you need. Our AI matches you with verified suppliers, auto-generates RFQs, guides negotiation, and predicts delivery risk — so your team focuses on decisions, not paperwork.',
  points: ['Natural language sourcing queries', 'Smart supplier matching & scoring', 'Auto RFQ generation in seconds', 'Negotiation guidance & risk prediction'],
  for: 'All Marketplace Buyers',
  demo: <ProcurementDemo data-id="element-66" />
}];
export function AIProducts() {
  const [active, setActive] = useState(0);
  return <section id="ai-products" className="py-24 bg-[#FAFAF8]" data-id="element-67">
      <div className="max-w-6xl mx-auto px-5 lg:px-8" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-14" data-id="element-69">
          <p className="text-xs font-inter font-semibold text-[#E8500A] tracking-[0.18em] uppercase mb-4" data-id="element-70">
            AI Products
          </p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4" data-id="element-71">
            <h2 className="font-jakarta text-4xl md:text-5xl font-extrabold text-[#0F0E0C] leading-tight max-w-lg" data-id="element-72">
              Intelligence Built
              <br data-id="element-73" />
              for <span className="gradient-text" data-id="element-74">Textile Trade.</span>
            </h2>
            <p className="text-[#5C5A55] font-inter max-w-xs text-base leading-relaxed" data-id="element-75">
              Two AI tools that transform how the yarn industry buys, sells, and
              plans.
            </p>
          </div>
        </motion.div>

        {/* Tab switcher */}
        <div className="flex gap-1 p-1 rounded-xl border border-[#E8E4DC] bg-[#F5F4F0] w-fit mb-12" data-id="element-76">
          {products.map((p, i) => <motion.button key={p.id} onClick={() => setActive(i)} whileTap={{
          scale: 0.97
        }} className={`px-5 py-2.5 rounded-lg text-sm font-inter font-medium transition-all duration-200 ${active === i ? 'bg-white text-[#0F0E0C] shadow-sm border border-[#E8E4DC]' : 'text-[#9B9890] hover:text-[#5C5A55]'}`} data-id="element-77">
              {p.label}
            </motion.button>)}
        </div>

        {/* Content */}
        <AnimatePresence mode="wait" data-id="element-78">
          {products.map((p, idx) => active === idx ? <motion.div key={p.id} initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -12
        }} transition={{
          duration: 0.35
        }} className="grid lg:grid-cols-2 gap-14 items-start" data-id="element-79">
                <div data-id="element-80">
                  <div className="text-[11px] font-inter font-semibold text-[#E8500A] tracking-[0.18em] uppercase mb-4" data-id="element-81">
                    {p.eyebrow}
                  </div>
                  <h3 className="font-jakarta text-3xl md:text-4xl font-extrabold text-[#0F0E0C] leading-tight mb-3" data-id="element-82">
                    {p.title}
                  </h3>
                  <p className="text-base text-[#E8500A] font-inter font-semibold mb-5" data-id="element-83">
                    {p.tagline}
                  </p>
                  <p className="text-[#5C5A55] font-inter leading-relaxed mb-8 text-base" data-id="element-84">
                    {p.description}
                  </p>

                  <div className="space-y-3 mb-8" data-id="element-85">
                    {p.points.map((point, i) => <motion.div key={i} initial={{
                opacity: 0,
                x: -8
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: i * 0.07
              }} className="flex items-center gap-3" data-id="element-86">
                        <div className="w-5 h-5 rounded-full bg-[#E8500A]/10 border border-[#E8500A]/20 flex items-center justify-center flex-shrink-0" data-id="element-87">
                          <svg className="w-2.5 h-2.5 text-[#E8500A]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-88">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" data-id="element-89" />
                          </svg>
                        </div>
                        <span className="text-sm text-[#5C5A55] font-inter" data-id="element-90">
                          {point}
                        </span>
                      </motion.div>)}
                  </div>

                  <div className="flex items-center gap-3 mb-8 py-3 border-t border-[#E8E4DC]" data-id="element-91">
                    <span className="text-xs text-[#9B9890] font-inter" data-id="element-92">
                      Built for:
                    </span>
                    <span className="text-xs text-[#0F0E0C] font-inter font-bold" data-id="element-93">
                      {p.for}
                    </span>
                  </div>

                  <motion.a href="#" whileHover={{
              scale: 1.02,
              y: -1
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center gap-2 px-6 py-3 bg-[#E8500A] hover:bg-[#D14508] text-white font-semibold rounded-xl transition-colors font-inter text-sm group shadow-md shadow-[#E8500A]/15" data-id="element-94">
                    Request Access
                    <svg className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-95">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-96" />
                    </svg>
                  </motion.a>
                </div>

                <div className="lg:sticky lg:top-24" data-id="element-97">{p.demo}</div>
              </motion.div> : null)}
        </AnimatePresence>
      </div>
    </section>;
}